import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiPut, apiputFormData } from '../../../API/Api_Url';

function FreelancerProfileUpdate({ ProUserdata, ChangeTab, GetUserProfile }) {
    const [isUploading, setIsUploading] = useState(false);

    const [fullName, setFullName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [city, setCity] = useState('');
    const [location, setLocation] = useState('');
    const [address, setAddress] = useState('');
    const [qualifications, setQualifications] = useState('');
    const [yearsOfExperience, setYearsOfExperience] = useState('');
    const [employers, setEmployers] = useState('');
    const [serviceArea, setServiceArea] = useState('');
    const [additionalNotes, setAdditionalNotes] = useState('');
    const [specializations, setSpecializations] = useState([]);
    const [specInput, setSpecInput] = useState('');


    useEffect(() => {
        if (!ProUserdata) return;
        setFullName(ProUserdata.fullName || ProUserdata?.name || '');
        setCompanyName(ProUserdata.companyName || '');
        setEmailAddress(ProUserdata.emailAddress || ProUserdata.email || '');
        setPhoneNumber(ProUserdata.phoneNumber || ProUserdata.phone || '');
        setCity(ProUserdata.City || '');
        setLocation(ProUserdata.Location || '');
        setAddress(ProUserdata.address || ProUserdata.companyAddress || '');
        setQualifications(ProUserdata.qualifications || '');
        setYearsOfExperience(ProUserdata.yearsOfExperience ?? '');
        setEmployers(ProUserdata.employers || '');
        setServiceArea(ProUserdata.serviceArea || '');
        setAdditionalNotes(ProUserdata.additionalNotes || '');
        setSpecializations(ProUserdata.specializationsOfExpertise);

    }, [ProUserdata]);


    const addSpecialization = (value) => {
        const v = (value || specInput || '').trim();
        if (!v) return;
        if (specializations.includes(v)) {
            setSpecInput('');
            return;
        }
        setSpecializations((s) => [...s, v]);
        setSpecInput('');
    };

    const removeSpecialization = (index) => {
        setSpecializations((s) => s.filter((_, i) => i !== index));
    };

    const onSpecKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            addSpecialization();
        }
    };

    const handleUpdateProfile = async () => {
        try {
            setIsUploading(true);

            const formData = new FormData();
            formData.append("fullName", fullName);
            formData.append("companyName", companyName);
            formData.append("emailAddress", emailAddress);
            formData.append("phoneNumber", phoneNumber);
            formData.append("City", city);
            formData.append("Location", location);
            formData.append("address", address);
            formData.append("qualifications", qualifications);
            formData.append("yearsOfExperience", Number(yearsOfExperience) || 0);
            formData.append("employers", employers);
            formData.append("serviceArea", serviceArea);
            formData.append("additionalNotes", additionalNotes);

            specializations.forEach((spec, index) => {
                formData.append(`specializationsOfExpertise[${index}]`, spec);
            });

            let response = await apiputFormData("api/freelance-engineer/update", formData);

            if (response?.data) {
                toast.success("Profile updated successfully!");
                GetUserProfile();
                ChangeTab("Profile");
            } else {
                toast.error(response?.message || "Failed to update profile");
            }
        } catch (err) {
            console.error("Update error:", err);
            toast.error("Error updating profile. See console for details.");
        } finally {
            setIsUploading(false);
        }
    };


    return (
        <div className="mx-auto space-y-6 p-4">
            <section className="bg-white shadow-xl rounded-2xl p-8 border border-gray-100">
                <h3 className="text-2xl font-bold text-gray-800 mb-6">Edit Freelancer Enginner Profile</h3>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <InputField label="Full Name" value={fullName} setValue={setFullName} />
                    <InputField label="Company Name" value={companyName} setValue={setCompanyName} />
                    <InputField label="Email Address" value={emailAddress} setValue={setEmailAddress} type="email" />
                    <InputField label="Mobile Number" value={phoneNumber} setValue={setPhoneNumber} type="tel" />
                    <InputField label="City" value={city} setValue={setCity} />
                    <InputField label="Location" value={location} setValue={setLocation} />
                    <InputField label="Address" value={address} setValue={setAddress} />
                    <InputField label="Qualifications" value={qualifications} setValue={setQualifications} />
                    <InputField label="Years of Experience" value={yearsOfExperience} setValue={setYearsOfExperience} type="number" />
                    <InputField label="Employers (count or names)" value={employers} setValue={setEmployers} />
                    <InputField label="Service Area" value={serviceArea} setValue={setServiceArea} />
                </div>

                <div className="mt-6">
                    <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Specializations</label>
                    <div className="flex gap-2 items-center">
                        <input
                            value={specInput}
                            onChange={(e) => setSpecInput(e.target.value)}
                            onKeyDown={onSpecKeyDown}
                            placeholder="Type and press Enter"
                            className="flex-1 border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                        <button
                            type="button"
                            onClick={() => addSpecialization(specInput)}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg"
                        >
                            Add
                        </button>
                    </div>

                    <div className="flex flex-wrap gap-2 mt-3">
                        {specializations.map((s, idx) => (
                            <div key={idx} className="px-3 py-1 bg-gray-100 border rounded-full flex items-center gap-2">
                                <span className="text-sm">{s}</span>
                                <button
                                    onClick={() => removeSpecialization(idx)}
                                    className="text-xs text-red-500 ml-2"
                                    type="button"
                                >
                                    &times;
                                </button>
                            </div>
                        ))}
                        {specializations.length === 0 && <div className="text-sm text-gray-400">No specializations added</div>}
                    </div>
                </div>

                <div className="mt-6">
                    <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">Additional Notes</label>
                    <textarea
                        value={additionalNotes}
                        onChange={(e) => setAdditionalNotes(e.target.value)}
                        rows={3}
                        className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                </div>


                <div className="mt-8 pt-6 border-t border-gray-200 flex gap-3 items-center">
                    <button
                        onClick={handleUpdateProfile}
                        disabled={isUploading}
                        className="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 transition-all duration-200"
                    >
                        {isUploading ? 'Updating...' : 'Save Changes'}
                    </button>

                    <button
                        onClick={() => (typeof ChangeTab === 'function' ? ChangeTab('Profile') : null)}
                        className="px-4 py-2 border rounded-lg"
                    >
                        Cancel
                    </button>
                </div>
            </section>
        </div>
    );
}

const InputField = ({ label, value, setValue, type = 'text' }) => (
    <div>
        <label className="block text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">{label}</label>
        <input
            type={type}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
    </div>
);

export default FreelancerProfileUpdate;
